import _ from 'lodash';
import { getAgsApiUrl, smb_fetch } from '@/api/operator/fetch';


/**
 * 格式化列表数据
 * @return
 */
const formatDistributeList = (res) => {
  const { data } = res;
  if(!data) {
    return;
  }
  const { list } = data;
  if(!list) {
    return;
  }
  data.list = _.map(list, (item) => {
    const { company: baseCompany, distributeLead } = item;
    if(baseCompany) {
      item['company-companyName'] = baseCompany.companyName;
      item['company-industryIds'] = baseCompany.industryId;
      item['company-areaIds'] = baseCompany.areaId;
    }
    if(distributeLead) {
      const { order, company } = distributeLead;
      item['distributeLead-agencyId'] = distributeLead.agencyId; // 分发服务商
      item['distributeLead-leadId'] = distributeLead.leadId; // 分发线索ID
      item['distributeLead-progressStatus'] = distributeLead.progressStatus; // 分发线索状态
      item['distributeLead-ownerName'] = distributeLead.ownerName; // 分发线索跟进销售
      item['distributeLead-ownerTeamName'] = distributeLead.ownerTeamName; // 分发线索所属团队
      if(company) {
        item['distributeLead-company-companyName'] = company.companyName; // 分发线索公司名称
      }
      if(order) {
        item['distributeLead-order-orderingProductId'] = order.orderingProductIds || order.orderingProductId; // 分发线索提单产品
        item['distributeLead-order-orderPaymentConfirmedTime'] = order.orderPaymentConfirmedTime; // 分发线索到款审批通过时间
        item['distributeLead-order-firstPaymentAmount'] = order.firstPaymentAmount; // 分发线索到款金额
        item['distributeLead-order-serviceFee'] = order.firstPaymentAmount - order.serviceFee; // 分发线索广告费 首次到款金额 - 服务费
      }
    }
    return item;
  });
  return {
    ...res,
    data,
  };
};


/**
 * 1.分发池线索列表
 * @return
 */
export const getDistributePoolList = (data) => {
  const url = getAgsApiUrl('v2/lead', 'distribute-pool/search');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    data,
  );
  delete params.data?.stepStatuses; // 删掉无需提交的字段
  return smb_fetch(url, params, false, false).then((res) => (formatDistributeList(res)));
};

/**
 * 5. 从分发池分发给服务商
 */
export const distributeAgency = (data) => {
  // URL: /v2/potential/distribute-pool/distribute-agency
  // {
  //   "leadIds": [1, 2, 3, 4],
  //   "distributeAgencyId": 44944
  // }
  const url = getAgsApiUrl('v2/potential', 'distribute-pool/distribute-agency');
  return smb_fetch(url, {
    method: 'POST',
    data,
    contentType: 'application/json',
  }, false, false);
};

/**
 * 6.从分发池领回
 * @return
 */
export const obtainPool = (data) => {
  // URL: /v2/potential/distribute-pool/obtain
  // {
  //   "leadIds": [1, 2, 3, 4]
  // }
  const url = getAgsApiUrl('v2/potential', 'distribute-pool/obtain');
  return smb_fetch(url, {
    method: 'POST',
    data,
    contentType: 'application/json',
  }, false, false);
};


/**
 * 获取分发线索详情里的用户名
 * @return
 */
export const getDistributeUserInfo = (data) => {
  const{
    agencyId = '',
    userId = '',
  } = data || {};
  const url = getAgsApiUrl(`user/${agencyId}/${userId}`);
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params, false, false);
};

/**
 * 获取电话录音
 * @return
 */
export const getRecordDetail = (params) => {
  const{
    data,
    agencyId,
  } = params || {};
  const url = getAgsApiUrl(`record/detail?agencyId=${agencyId}`);
  return smb_fetch(url, {
    method: 'POST',
    data,
    contentType: 'application/json',
  }, false, false);
};

/**
 * 分发池下载
 * @return
 */
export const downloadPoolList = (data) => {
  const url = getAgsApiUrl('v2/distribute-pool', 'download');
  delete data.stepStatuses; // 删掉无需提交的字段
  return smb_fetch(url, {
  // return smb_fetch('/v2/distribute-pool/download', {
    method: 'POST',
    data,
    contentType: 'application/json',
  }, false, false);
};

/**
 * 分发池获取下载链接
 * @return
 */

export const getDownloadPoolListLink = (data) => {
  const{
    agencyId = '',
    userId = '',
  } = data || {};
  const url = getAgsApiUrl(`download/result`);
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );
  return smb_fetch(url, params, false, false);
};

